export const API_GET_ALL_PRODUCTS= "/admin/productos/";
export const API_GET_SEARCH_PRODUCTS = "/admin/productos/buscar/";
export const API_POST_SAVE_PRODUCTS = "/admin/productos/registro-producto";
export const API_PUT_UPDATE_PRODUCTS = "/admin/productos/actualizar-producto/";